module.exports = __webpack_public_path__ + "img/have-audited.16d4bf91.png";